module.exports = __webpack_public_path__ + "img/INTERIOR-S-CROSS-6.d507fe9c.jpg";